// core/nav — jembatan navigasi + refresh satu-arah. Shell mendaftarkan handler; modul
// memanggil tanpa mengimpor shell (hindari import melingkar). Port openTab/switchTab v0.18.
let handler: ((id: string) => void) | null = null;
let countsHandler: (() => void) | null = null;

/** Dipanggil shell sekali saat setup: daftarkan fungsi navigasi. */
export const onNavigate = (h: (id: string) => void): void => { handler = h; };

/** Pindah ke menu `id` (mis. 'perlu_diperhatikan' / 'st_Dikerjakan'). No-op bila belum siap. */
export const goto = (id: string): void => { handler?.(id); };

/** Shell mendaftarkan pembaruan badge angka status di sidebar. */
export const onRefreshCounts = (h: () => void): void => { countsHandler = h; };

/** Modul memanggil setelah transisi/mutasi status agar badge sidebar ikut ter-update (auto, tanpa refresh manual). */
export const refreshCounts = (): void => { countsHandler?.(); };

// Menu yang sedang dibuka. Dipakai kontrol EXPORT agar izinnya bisa diatur per menu tanpa
// menyentuh 12 modul: guard cukup bertanya "ini export dari menu apa?".
let aktif = 'dashboard';
export const setMenuAktif = (id: string): void => { aktif = id; };
export const menuAktif = (): string => aktif;
